import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class CardLookUpSample extends Component {
    getOrderId() {
        const { order_id, selectedProgLangId } = this.props;
        if(order_id === "none") {
            switch(selectedProgLangId) {
                case _DOTNET:
                    return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
                case _JAVA:
                    return `"Test"+createDate.getTime()`;
                case _PHP:
                    return `'ord-'.date("dmy-G:i:s")`;
                default:
                    return "";
            }
        }
        else
            return `"${order_id}"`;
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    render() {
        const { storeId, apiToken, pan, selectedProgLangId } = this.props;

        switch(selectedProgLangId) {
            case _DOTNET:
                return (
                    <pre className="sampleCode">
{`using Moneris;

public class TestCanadaMpiCardLookup
{
 public static void Main(string[] args)
 {
  string store_id = "`}{this.getValue(storeId, "storeId")}{`";
  string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";

  string order_id = ${this.getOrderId()};

  string pan = "`}{this.getValue(pan, "pan")}{`";
    
  string processing_country_code = "CA";

  MpiCardLookup mpiCardLookup = new MpiCardLookup();
  mpiCardLookup.SetOrderId(order_id);
  mpiCardLookup.SetPan(pan);

  mpiCardLookup
  .SetNotificationUrl("https://yournotificationurl.com");
  //(Website URL that will receive 3DS Method Completion response from ACS)
  
  HttpsPostRequest mpgReq = new HttpsPostRequest();
  mpgReq.SetProcCountryCode(processing_country_code);

  mpgReq.SetTestMode(true);//false or comment out this 
  line for production transactions
  
  mpgReq.SetStoreId(store_id);
  mpgReq.SetApiToken(api_token);
  mpgReq.SetTransaction(mpiCardLookup);
  mpgReq.Send();

  try
  {
   Receipt receipt = mpgReq.GetReceipt();

   Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
   Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
   Console.WriteLine("Message = " + receipt.GetMessage());
   Console.WriteLine("Messagetype = " + receipt.GetMpiMessageType());
   Console.WriteLine("ThreeDSMethodURL = " + receipt.GetMpiThreeDSMethodURL());
   Console.WriteLine("ThreeDSMethodData = " + receipt.GetMpiThreeDSMethodData());
   Console.WriteLine("ThreeDSServerTransID = " + receipt.GetMpiThreeDSServerTransID());
  }
  catch (Exception e)
  {
   Console.WriteLine(e);
  }
 }
}
`}
                </pre>)

        case _JAVA:
            return (
                <pre className="sampleCode">
{`package Canada;

import JavaAPI.*;

public class TestCanadaMpiCardLookup
{
 public static void main(String[] args)
 {
  String store_id = "`}{this.getValue(storeId, "storeId")}{`";
  String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
  java.util.Date createDate = new java.util.Date();
  String order_id = ${this.getOrderId()};
  String pan = "`}{this.getValue(pan, "pan")}{`";
  String processing_country_code = "CA";
  MpiCardLookup mpiCardLookup = new MpiCardLookup();
  mpiCardLookup.setOrderId(order_id);
  mpiCardLookup.setPan(pan);
  //mpiCardLookup.setDataKey("8OOXGiwxgvfbZngigVFeld9d2"); 
  //Optional - For Moneris Vault and Hosted
  Tokenization tokens in place of setPan
  mpiCardLookup.setNotificationUrl("https://yournotificationurl.com"); 
  //(Website URL that will receive 3DS Method Completion response from ACS)


  //*****************OPTIONAL VARIABLES******************

  HttpsPostRequest mpgReq = new HttpsPostRequest();
  mpgReq.setProcCountryCode(processing_country_code);

  mpgReq.setTestMode(true); 
  //false or comment out this line for production transactions

  mpgReq.setStoreId(store_id);
  mpgReq.setApiToken(api_token);
  mpgReq.setTransaction(mpiCardLookup);
  mpgReq.send();

  //********************* REQUEST *********************
  try
  {
   Receipt receipt = mpgReq.getReceipt();
   System.out.println("ResponseCode = " + receipt.getResponseCode());
   System.out.println("ReceiptId = " + receipt.getReceiptId());
   System.out.println("Message = " + receipt.getMessage());
   System.out.println("MessageType = " + receipt.getMpiMessageType());
   System.out.println("ThreeDSMethodURL = " + receipt.getMpiThreeDSMethodURL());
   System.out.println("ThreeDSMethodData = " + receipt.getMpiThreeDSMethodData());
   System.out.println("ThreeDSServerTransId = " + receipt.getMpiThreeDSServerTransId());
  }
  catch (Exception e)
  {
   e.printStackTrace();
  }
 }
}
`}
                </pre>
            )

        case _PHP:
            return (
                <pre className="sampleCode">
{`<?php

require "../../mpgClasses.php";

/*********************** Request Variables *************************/
$store_id = "`}{this.getValue(storeId, "storeId")}{`";
$api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
$order_id = ${this.getOrderId()};
$pan = "`}{this.getValue(pan, "pan")}{`";
$mpiCardLookup = new MpiCardLookup();
$mpiCardLookup->setOrderId($order_id);
$mpiCardLookup->setPan($pan);
//$mpiCardLookup->setDataKey("8OOXGiwxgvfbZngigVFeld9d2"); //Optional - For Moneris Vault and Hosted
Tokenization tokens in place of setPan
$mpiCardLookup->setNotificationUrl("https://yournotificationurl.com"); // (Website URL that will
receive 3DS Method Completion response from ACS)

/******************** Transaction Object **************************/
$mpgTxn = new mpgTransaction($mpiCardLookup);

/*********************** Request Object ***************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions

/*********************** HTTPS Post Object ************************/
$mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest);

/*************************** Response ****************************/
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nReceiptId = " . $mpgResponse->getReceiptId());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nMessageType = " . $mpgResponse->getMpiMessageType());
print("\\nThreeDSMethodURL = " . $mpgResponse->getMpiThreeDSMethodURL());
print("\\nThreeDSMethodData = " . $mpgResponse->getMpiThreeDSMethodData());
print("\\nThreeDSServerTransId = " . $mpgResponse->getMpiThreeDSServerTransId());
?>
`}
                </pre>
            )
        default:
            return null
        }
    }
}

const mapStateToProps = state => {
  const { storeId, apiToken, order_id, pan, onEditId } = state.threeDSTwo.main.config;
  const { selection } = state.common.progLangList;
  return { storeId, apiToken, order_id, pan, selectedProgLangId: selection, onEditId };
}

export default connect(mapStateToProps, {})(CardLookUpSample)
